export const AMORTIZATION_TYPE_OTRO = 6;
export const PAYMENT_FREQUENCY_OTRO = 8;

export const isOtroAmortization = (id: number | null | undefined): boolean =>
  id === AMORTIZATION_TYPE_OTRO;

export const isOtroPaymentFrequency = (id: number | null | undefined): boolean =>
  id === PAYMENT_FREQUENCY_OTRO;

export const requiresManualInstallmentPlan = (
  amortizationTypeId: number | null | undefined,
  paymentFrequencyTypeId: number | null | undefined
): boolean =>
  isOtroAmortization(amortizationTypeId) || isOtroPaymentFrequency(paymentFrequencyTypeId);

export const isValidOtroPair = (
  amortizationTypeId: number | null | undefined,
  paymentFrequencyTypeId: number | null | undefined
): boolean =>
  isOtroAmortization(amortizationTypeId) && isOtroPaymentFrequency(paymentFrequencyTypeId);
